import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';

export const FavoriteIcon = styled(FontAwesomeIcon)(({ theme, disabled }) => ({
  color: disabled ? theme.palette.colors.lower : theme.palette.colors.star,
  cursor: disabled ? 'auto' : 'pointer',
  fontSize: '16px',
}));
